export default "__VITE_ASSET__DnfMfND5__"